interface ClosedRow {
  ref: string;
  researcher: string;
  project: string;
  closed: string;
  leadTime: string;
  completeness: number;
  fillWidth: string;
  outcome: string;
  outcomeVariant: "success" | "warning" | "danger";
}

const ROWS: ClosedRow[] = [
  {
    ref: "EA-2026-039",
    researcher: "An Declercq",
    project: "Focusgroep over onderwijs en diversiteit",
    closed: "19 jun",
    leadTime: "9 d",
    completeness: 95,
    fillWidth: "w-[95%]",
    outcome: "Positief",
    outcomeVariant: "success",
  },
  {
    ref: "EA-2026-027",
    researcher: "Ines Mortier",
    project: "Longitudinale studie naar pubergedrag",
    closed: "14 jun",
    leadTime: "18 d",
    completeness: 72,
    fillWidth: "w-[72%]",
    outcome: "Voorwaardelijk",
    outcomeVariant: "warning",
  },
  {
    ref: "EA-2026-025",
    researcher: "Remi Claes",
    project: "Experiment over sociale vergelijking",
    closed: "10 jun",
    leadTime: "11 d",
    completeness: 88,
    fillWidth: "w-[88%]",
    outcome: "Positief",
    outcomeVariant: "success",
  },
  {
    ref: "EA-2026-022",
    researcher: "Amber Gilles",
    project: "Interviews over seksueel grensoverschrijdend gedrag",
    closed: "6 jun",
    leadTime: "22 d",
    completeness: 60,
    fillWidth: "w-[60%]",
    outcome: "Uitgesteld",
    outcomeVariant: "danger",
  },
  {
    ref: "EA-2026-019",
    researcher: "Dries Van Acker",
    project: "Survey over vertrouwen in de overheid",
    closed: "2 jun",
    leadTime: "8 d",
    completeness: 93,
    fillWidth: "w-[93%]",
    outcome: "Positief",
    outcomeVariant: "success",
  },
  {
    ref: "EA-2026-016",
    researcher: "Fien Lemmens",
    project: "Observatie van online radicalisering",
    closed: "28 mei",
    leadTime: "16 d",
    completeness: 79,
    fillWidth: "w-[79%]",
    outcome: "Voorwaardelijk",
    outcomeVariant: "warning",
  },
];

export function AfgerondPage() {
  return (
    <section>
      <div className="page-head">
        <div>
          <h1>Afgeronde dossiers</h1>
          <p>Academisch jaar 2025–2026 · 112 afgesloten</p>
        </div>
        <button className="btn btn--ghost">Exporteer overzicht</button>
      </div>

      <div className="stats ua-mb-space">
        <div className="stat">
          <div className="stat__label">Positief advies</div>
          <div className="stat__value">74</div>
          <div className="stat__delta up">66%</div>
        </div>
        <div className="stat">
          <div className="stat__label">Voorwaardelijk</div>
          <div className="stat__value">29</div>
          <div className="stat__delta">26%</div>
        </div>
        <div className="stat">
          <div className="stat__label">Negatief / uitgesteld</div>
          <div className="stat__value">9</div>
          <div className="stat__delta down">8%</div>
        </div>
        <div className="stat">
          <div className="stat__label">Gem. doorlooptijd</div>
          <div className="stat__value">14 d</div>
          <div className="stat__delta down">▼ 3d vs. vorig jaar</div>
        </div>
      </div>

      <div className="card">
        <table className="table">
          <thead>
            <tr>
              <th>Ref.</th>
              <th>Onderzoeker / Project</th>
              <th>Afgesloten</th>
              <th>Doorlooptijd</th>
              <th>AI volledigheid</th>
              <th>Uitkomst</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map((row) => (
              <tr key={row.ref}>
                <td className="ua-muted-xs">{row.ref}</td>
                <td>
                  <div className="ua-bold-sm">{row.researcher}</div>
                  <div className="ua-muted-xs">{row.project}</div>
                </td>
                <td>{row.closed}</td>
                <td>{row.leadTime}</td>
                <td>
                  <div className="mini-bar">
                    <div className={`mini-bar__fill ${row.fillWidth}`} />
                  </div>
                  <span className="ua-muted-xs">{row.completeness}%</span>
                </td>
                <td>
                  <span className={`badge badge--${row.outcomeVariant}`}>{row.outcome}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="ua-pager">
          <span className="ua-muted-sm">1–6 van 112</span>
          <div className="ua-flex-actions">
            <button className="btn btn--ghost px-3 py-[5px] text-[13px]">← Vorige</button>
            <button className="btn btn--ghost px-3 py-[5px] text-[13px]">Volgende →</button>
          </div>
        </div>
      </div>
    </section>
  );
}
